<div [ngClass]="isMobile === true ? 'contact-wrapper-mobil' : 'contact-wrapper'">
  <colimo-page-header [heading]="'sidenav.contactPage'"> </colimo-page-header>
  <h1>{{ 'contactPage.contactPageLink' | translate }}</h1>
  <p>
    {{ 'contactPage.contactUs' | translate }}
    <a (click)="openContactPage()" class="link-external">
      <mat-icon class="material-icons-outlined link-external">open_in_new</mat-icon>
      {{ 'contactPage.contactPageLink' | translate }}
    </a>
  </p>
</div>
